import { render, staticRenderFns } from "./TablesGovernmentPage.vue?vue&type=template&id=7cffddb6&scoped=true"
import script from "./TablesGovernmentPage.vue?vue&type=script&lang=js"
export * from "./TablesGovernmentPage.vue?vue&type=script&lang=js"
import style0 from "./TablesGovernmentPage.vue?vue&type=style&index=0&id=7cffddb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffddb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cffddb6')) {
      api.createRecord('7cffddb6', component.options)
    } else {
      api.reload('7cffddb6', component.options)
    }
    module.hot.accept("./TablesGovernmentPage.vue?vue&type=template&id=7cffddb6&scoped=true", function () {
      api.rerender('7cffddb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/TablesGovernmentPage.vue"
export default component.exports